export const ErrorCardStyles = {
    errorCard: {
        wrapper: "flex flex-col items-center justify-center py-8 px-6 text-center",
        iconContainer: "w-108 h-108 flex items-center justify-center mb-2",
        iconImage: "w-[108px] h-[108px]",
    
        title: "text-xl font-semibold text-gray-800 mb-4",
        description: "text-gray-500 mb-8",
        
        buttonContainer: "w-full flex justify-center",
        closeButton: `!py-3`
    }
};